<script>
    import { metaInfo } from "@/core/MetaInfo";
    import StoreContent from "@/components/StoreContent";

    export default {
        name: "Store",
        components: { StoreContent },
        computed: {
            sliderOptions() {
                return {
                    isScrollbar: false,
                    isBullets: true,
                    isArrow: true,
                    arrowPosition: "bottom",
                    test: "33",
                };
            },
        },
        metaInfo() {
            return metaInfo.getMeta("store");
        },
    };
</script>

<template>
    <store-content
        class="store-content"
        catalog-button-text="Выбрать товары"
        :slider-options="sliderOptions"
        :slides-count="{ msk: 7, spb: 7, ekb: 7, krd: 5 }"
        icon="navigation"
    >
        <template #subtitle>
            Познакомьтесь с гаджетами перед покупкой! Вся линейка Chipolo представлена в
            магазинах Madrobots. <br />
            Наши консультанты помогут выбрать подходящую модель.
        </template>
        <template #description-title>Chipolo и Madrobots</template>
        <template #description-subtitle>
            <a href="https://madrobots.ru/" target="_blank">Madrobots.ru</a> — оператор
            официального интернет-магазина Chipolo в России.
        </template>
        <template #description-text>
            Ждем вас в гости! Понравилось несколько моделей? Добавьте в заказ все, приходите в
            наш магазин — и возьмите подходящие.
        </template>
    </store-content>
</template>

<style lang="scss">
    .store-content {
        .store__subtitle {
            color: var(--secondary-text);
            font-size: 16px;
            line-height: 28px;
            font-weight: 600;
        }

        .store-shop__slider {
            .c-slider__bottom-wrapper {
                display: flex;
            }
            .c-slider__arrow {
                display: none;
                @include bp($bp-desktop-sm) {
                    display: block;
                }
            }
        }

        .store-description__decors {
            top: -32px;
            @include bp($bp-desktop-sm) {
                top: -80px;
            }
            @include bp($bp-desktop-md) {
                top: -110px;
            }
        }
    }
</style>
